const isStaging =
  process.env.GATSBY_ENVIRONMENT === 'STAGING' &&
  process.env.GATSBY_CONTENTFUL_PREVIEW_ENABLED === 'active'
    ? true
    : false

export const token = isStaging
  ? process.env.GATSBY_CONTENTFUL_PREVIEW_ACCESS_TOKEN
  : process.env.GATSBY_CONTENTFUL_DELIVERY_ACCESS_TOKEN

export const host = isStaging
  ? process.env.GATSBY_CONTENTFUL_HOST
  : 'cdn.contentful.com'

export const contentfulUrl = `https://${host}/spaces/${process.env.GATSBY_CONTENTFUL_SPACE_ID}/environments/${process.env.GATSBY_CONTENTFUL_ENVIRONMENT}`
export const header = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
}
